<ion-header>
    <ion-toolbar mode="ios">
        <ion-buttons slot="end">
            <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-buttons slot="start">
            <ng-content select="[backButton]"></ng-content>
        </ion-buttons>
    </ion-toolbar>
    <ng-content select="[searchBar]"></ng-content>
</ion-header>
